import { DynamicFormsRoutingModule } from './dynamic.Forms-routing.module';
// export function createTranslateLoader(http: HttpClient) {
//   return new TranslateHttpLoader(http, './translation/', '.json');
// }

import { NgModule } from '@angular/core';
import {
  NbMenuModule,
  NbCardModule,
  NbButtonModule,
  NbLayoutModule,
  NbTabsetModule,
  NbSelectModule,
  NbListModule,
  NbDialogModule,
  NbRadioModule,
  NbToggleModule,
  NbWindowModule,
  NbInputModule,
  NbStepperModule,
  NbIconModule,
  NbAccordionModule,
  NbDatepickerModule,
} from '@nebular/theme';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ngx-custom-validators';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeModule } from '../../@theme/theme.module';
import { GetFormMasterComponent } from './formsMaster/components/get/get.component';
import { GetFormFieldComponent } from './formsFields/components/get/get.component';
import { GetFieldPropsComponent } from './forms.properties/components/get/get.component';
import { CreateFormComponent } from './formsMaster/components/create/create.component';
import { CreateFieldComponent } from './formsFields/components/create/create.component';
import { GetSourceMasterComponent } from './source.master/components/get/get.component';
import { CreateDataSourceComponent } from './source.master/components/create/create.component';
import { GetSourceValueComponent } from './sources.values/components/get/get.component';
import { CreateDataSourceValuesComponent } from './sources.values/components/create/create.component';
import { GetFormMasterFieldsComponent } from './formsMaster/components/get.fields/get.component';
import { DynamicFormsComponent } from './dynamicForms.Component';

import { DeleteFormComponent } from './formsMaster/components/delete/delete.component';
import { UpdateFormComponent } from './formsMaster/components/update/update.component';
import { DeleteSourceComponent } from './source.master/components/delete/delete.component';
import { UpdateSourceComponent } from './source.master/components/update/update.component';
import { DeleteSourceValueComponent } from './sources.values/components/delete/delete.component';
import { DeleteFormFieldComponent } from './formsFields/components/delete/delete.component';
import { GetFormMasterFieldsPopupComponent } from './formsMaster/components/get.fields.popup/get.component';
import { GetFormMasterFieldsValuesComponent } from './formsValues/components/get.fields/get.component';
import { MatStepperModule } from '@angular/material/stepper';
import { GetFormSectionComponent } from './forms.sections/components/get/get.component';
import { CreateFormSectionComponent } from './forms.sections/components/create/create.component';
import { DeleteSectionComponent } from './forms.sections/components/delete/delete.component';
import { UpdateSectionComponent } from './forms.sections/components/update/update.component';
import { UpdateFieldComponent } from './formsFields/components/update/update.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { UpdateDataSourceValuesComponent } from './sources.values/components/update/update.component';

@NgModule({
  imports: [
    NbMenuModule,
    NbCardModule,
    NbButtonModule,
    SharedModule,
    FormsModule,
    CustomFormsModule,
    NbLayoutModule,
    NbTabsetModule,
    NbSelectModule,
    NbListModule,
    NbDialogModule.forChild(),
    TranslateModule,
    NbRadioModule,
    NbToggleModule,
    DynamicFormsRoutingModule,
    NbIconModule,
    // TranslateModule.forChild({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: createTranslateLoader,
    //     deps: [HttpClient],
    //   },
    //   isolate: true,

    // }),
    NbInputModule,
    NbWindowModule.forChild(),
    ThemeModule,
    NbStepperModule,
    NbAccordionModule,
    NbDatepickerModule,
    RichTextEditorAllModule,
  ],
  declarations: [
    GetFormMasterComponent,
    GetFormFieldComponent,
    GetFieldPropsComponent,
    CreateFormComponent,
    CreateFieldComponent,
    GetSourceMasterComponent,
    CreateDataSourceComponent,
    GetSourceValueComponent,
    CreateDataSourceValuesComponent,
    GetFormMasterFieldsComponent,
    DynamicFormsComponent,
    DeleteFormFieldComponent,
    DeleteFormComponent,
    UpdateFormComponent,
    DeleteSourceComponent,
    UpdateSourceComponent,
    DeleteSourceValueComponent,
    GetFormMasterFieldsPopupComponent,
    GetFormMasterFieldsValuesComponent,
    GetFormSectionComponent,
    CreateFormSectionComponent,
    DeleteSectionComponent,
    UpdateSectionComponent,
    UpdateFieldComponent,
    UpdateDataSourceValuesComponent
  ],
  entryComponents: [
    GetFieldPropsComponent,
    CreateFormComponent,
    CreateFieldComponent,
    CreateDataSourceComponent,
    CreateDataSourceValuesComponent,
    GetFormMasterFieldsComponent,
    GetFormMasterFieldsPopupComponent,
    GetFormMasterFieldsValuesComponent,
    CreateFormSectionComponent,
    UpdateFormComponent,
    UpdateSectionComponent,
    UpdateFieldComponent,
    UpdateSourceComponent,
    UpdateDataSourceValuesComponent,
  ],
  exports: [GetFormMasterFieldsPopupComponent, GetFormMasterFieldsValuesComponent],
})
export class DynamicFormsModule {}
